import React from "react";
import { Card, Statistic, Tooltip, Typography } from "antd";
import { StarOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { SOPORTE_TEMA } from "../Chat/fasesSoporte";
import { AyudaEscalaPuntos } from "../Chat/escalaPuntos";
import { CARD_KPI_STYLE } from "./estilosReporteSoporte";

const { Text } = Typography;


const COLOR_CON_DATO = SOPORTE_TEMA.primario;

const CardPuntosHistoria = ({ promedio, mediana, ticketsConPuntos = 0, totalTickets = 0, etiquetaTicket = "reporte" }) => {
  const hayPuntos = ticketsConPuntos > 0 && promedio !== null && promedio !== undefined;

  return (
    <Card style={{ ...CARD_KPI_STYLE, flex: 1 }}>
      <Statistic
        title={
          <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
            Puntos promedio por {etiquetaTicket}
            <Tooltip title={<AyudaEscalaPuntos />} overlayStyle={{ maxWidth: 360 }}>
              <InfoCircleOutlined style={{ color: SOPORTE_TEMA.textSecondary, cursor: "help" }} />
            </Tooltip>
          </span>
        }
        value={hayPuntos ? promedio : "—"}
        prefix={<StarOutlined />}
        valueStyle={{ color: hayPuntos ? COLOR_CON_DATO : SOPORTE_TEMA.textSecondary }}
      />
      <Text type="secondary" style={{ fontSize: 11 }}>
        {hayPuntos ? (
          <>
            {mediana !== null && mediana !== undefined && <>mediana {mediana} · </>}
            {ticketsConPuntos} de {totalTickets} {etiquetaTicket}s calificados
          </>
        ) : (
          "todavía sin reportes calificados en Jira"
        )}
      </Text>
    </Card>
  );
};

export default CardPuntosHistoria;
